import Icon from '../components/Icon.vue'

Icon.register({
  'phone-volume': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M97.3 507C-32.5 377.1-32.3 166.7 97.3 37 103 31.3 111.9 30.4 118.6 34.6L183.4 75.1A17.2-17.2 0 0 0 190.3 96.1L157.9 177.1A17.2-17.2 0 0 0 140.2 187.8L84.4 182.2C63.3 240.5 63.8 304.7 84.4 361.8L140.2 356.2A17.2-17.2 0 0 0 157.9 366.9L190.3 447.9A17.2-17.2 0 0 0 183.4 468.9L118.6 509.4A17.2-17.2 0 0 0 97.3 507zM247.1 95.5C259 115.5 259 140.5 247.1 160.5 243.2 167.2 234 168.5 228.4 163.1L222.4 157.4C218.5 153.6 217.6 147.8 220.2 143A32.1-32.1 0 0 1 220.2 113C217.6 108.2 218.5 102.4 222.4 98.6L228.4 92.9C234 87.5 243.2 88.8 247.1 95.5zM338.9 4.3C399.1 75.9 399 180.2 338.9 251.7 334.4 257 326.4 257.5 321.4 252.6L315.6 247.1C311 242.7 310.6 235.6 314.6 230.7 364.3 171.2 364.3 84.8 314.6 25.3 310.6 20.4 311 13.3 315.6 8.9L321.4 3.4C326.4-1.5 334.4-1 338.9 4.3zM292.9 49.2C329 95.5 329 160.4 292.9 206.8 288.6 212.4 280.2 213 275.1 208.1L269.3 202.5C264.9 198.3 264.3 191.4 268 186.6 294.5 152 294.5 104 268 69.4 264.3 64.6 264.9 57.7 269.3 53.5L275.1 47.9C280.2 43 288.6 43.6 292.9 49.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/phone-volume.js
// module id = hG4Z
// module chunks = 144